'use client';

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { idbStorage } from '@/lib/idb-storage';

interface BookProgress {
  chapterId: string;
  page: number;
  updatedAt: number;
}

interface ReadingProgressState {
  /** Map of bookKey -> reading position */
  progress: Record<string, BookProgress>;
  saveProgress: (bookKey: string, chapterId: string, page: number) => void;
  getProgress: (bookKey: string) => BookProgress | null;
  clearProgress: (bookKey: string) => void;
}

/** Build a stable key from book title + fileName */
export function bookProgressKey(title: string, fileName?: string | null): string {
  return `${title}::${fileName || ''}`;
}

export const useReadingProgressStore = create<ReadingProgressState>()(
  persist(
    (set, get) => ({
      progress: {},

      saveProgress: (bookKey, chapterId, page) =>
        set((state) => ({
          progress: {
            ...state.progress,
            [bookKey]: { chapterId, page, updatedAt: Date.now() },
          },
        })),

      getProgress: (bookKey) => {
        return get().progress[bookKey] ?? null;
      },

      clearProgress: (bookKey) =>
        set((state) => {
          const { [bookKey]: _, ...rest } = state.progress;
          return { progress: rest };
        }),
    }),
    {
      name: 'bookshelf-reading-progress',
      storage: createJSONStorage(() => idbStorage),
    }
  )
);
